import React from 'react';
import { useEffect, useState, useRef, useContext } from 'react';
import { Routes, Route, Link, useNavigate, useLocation, Outlet, useParams, json } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { useInView } from 'react-intersection-observer';
import { useSpring, animated } from '@react-spring/web'
import toast, { Toaster } from 'react-hot-toast';
import html2canvas from 'html2canvas';

import { AddBlob, Setlib } from './store.js';
import { Static, ShowLoading, ShowToast, ImgResize, ImgUpload, ImgGet, ImgGetHas, ModalEditPf, ModalEditImg } from './util.js';
import { TimerLeft, TimerAgo } from './timer.js';
import { ImageLoader, ImgSlot } from './imgloader.js';
import { Adsense } from './ads.js';
import { AppDownloadModal } from './popup.js';

import Spinner from 'react-bootstrap/Spinner';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';

import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Modal from 'react-bootstrap/Modal';

import ImgNo from './img/NoImg.png';
import ImgVs from './img/vs.png';
import ImgNullSlot from './img/NoImg.png';
import ImgNullPf from './img/NullPf.jpg';



export function User(uuid, mod, admin) {

    const store = useSelector((state) => state);
    const bootstrap = require('bootstrap')
    const { addImgKey, loadImgs } = ImageLoader();

    const dispatch = useDispatch();

    const [moreRef, moreInView] = useInView();

    const modLib = mod == 'lib';
    const modLibModal = mod == 'libmodal';

    let [loading, loadingSet] = useState(false);
    let [loaded, loadedSet] = useState(false);

    const myData = { nick: '', lib: 0, used: 0, rnk: 0, mygame: 0, ingame: 0 };
    let [my, mySet] = useState(myData);
    let [lib, libSet] = useState([]);
    let [tags, tagsSet] = useState([]);

    // 모달 관련 state
    let [showModalGameSlot, showModalGameSlotSet] = useState(false);
    let [selectedSlot, selectedSlotSet] = useState(null);
    const modalContentRef = useRef(null);

    // 앱 다운로드 모달 state
    let [showAppDownloadModal, showAppDownloadModalSet] = useState(false);


    let selQz = useRef([]);

    let offset = useRef(0);


    let order = useRef(0);
    let orderFind = useRef(0);
    let [rendFind, rendFindSet] = useState(false);
    let [findword, findwordSet] = useState('');
    const findwordRef = useRef('%');
    let [findwordDone, findwordDoneSet] = useState('');

    let [more, moreSet] = useState(false);

    const taRefFind = useRef();

    const tabInit = useRef(false);
    const _ORDER = 'ulib_order';



    useEffect(() => {

    }, []);

    useEffect(() => {

        if (!uuid) {
            return;
        }

        const savedOrder = sessionStorage.getItem(_ORDER) === '1' ? 1 : 0;
        sessionStorage.setItem(_ORDER, String(savedOrder));
        order.current = savedOrder;

        rendFindSet(false);

        loadingSet(true);

        if (modLib) {
            ReOrderLib();
            console.log(uuid);
        }
        else {

            mySet(myData);

            axios.post(Static.SvrAddr + 'mypage', {
                user: uuid,
            }).then((res) => {

                console.log(res);
                mySet(res.data[0][0]);

                ReOrderLib();

            }).catch((err) => {
                console.log('mypage failed:', err?.message);
                console.log('Response status:', err?.response?.status);
                console.log('Response data:', err?.response?.data);
                loadedSet(true);
                loadingSet(false);
            })
        }


        ShowToast();



    }, [uuid])


    useEffect(() => {
        if (loading || offset.current == 0 || !more) {
            return;
        }

        if (moreInView) {
            console.log(moreInView, '무한 스크롤 요청 🎃')

            LoadQz();
        }

    }, [moreInView]);





    function ClickOrderTab() {

        tabInit.current = false;

        findwordRef.current = '%';
        ReOrderLib();
    }


    function SearchLib() {

        findwordDoneSet(findword);

        if (findword == '') {
            return;
        }

        let word = findword.replace(/\s+/g, '');

        if (word.length > 10) {
            alert("검색어가 너무 길어요.");
            return;
        }

        findwordRef.current = findword;

        ReOrderLib();
    }

    function ReOrderLib() {

        selQz.current = [];

        libSet([]);

        loadedSet(false);

        moreSet(false);

        offset.current = 0;

        LoadQz();
    }



    function LoadQz() {
        console.log(uuid);
        if (loading) {
            return;
        }
        loadingSet(true);

        let op = {
            order: order.current == 2 ? order.current + orderFind.current : order.current,
            offset: offset.current,
            find: findwordRef.current,
            user: modLib ? '%' : uuid
        }
        console.log(op);
        axios.post(Static.SvrAddr + 'lib', op).then((res) => {
            console.log(offset.current);

            console.log(res);

            let gd = res.data[0];

            for (let i = 0; i < gd.length; i++) {
                let d = gd[i];
                let cb = { p: false, c: [] };
                d.qz = typeof d.qz === 'string' ? JSON.parse(d.qz) : d.qz;

                for (let j = 0; j < d.qz.length; j++) {
                    cb.c.push(false);
                }


                AddLoadImg(d.uid, [d.qz[0]]);

                if (d.tag == '' || d.tag == null) {
                    d.tag = null;
                }
                else {
                    console.log(d.tag.replace(/#/g, ' #'));
                    d.tag = d.tag.replace(/#/g, ' #');
                }
            }

            loadImgs((urls) => {
                if (urls) {
                    console.log('모든 이미지가 성공적으로 로드되었습니다:', urls);
                } else {
                    console.error('이미지 로드 실패');
                }
            });

            if (offset.current == 0) {
                libSet([...gd]);
            }
            else {
                libSet([...lib, ...gd]);
            }

            console.log(gd);

            if (res.data.length >= 2) {
                tagsSet(res.data[1]);
            }
            console.log(tabInit.current);

            if (modLib && !tabInit.current) {
                const triggerTabList = document.querySelectorAll('#tab_tag button');
                triggerTabList.forEach(triggerEl => {
                    const tabTrigger = new bootstrap.Tab(triggerEl);

                    triggerEl.addEventListener('click', event => {
                        event.preventDefault();
                        tabTrigger.show();
                    })
                })

                const triggerEl = document.querySelector('#tab_tag button[data-bs-target="#all"]');
                if (triggerEl) {
                    bootstrap.Tab.getOrCreateInstance(triggerEl).show();
                }

                tabInit.current = true;
            }

            console.log(tabInit.current);

            loadedSet(true);

            LoadingDone(gd.length);

        }).catch((err) => {
            console.log('lib failed:', err?.message);
            console.log('Response status:', err?.response?.status);
            console.log('Response data:', err?.response?.data);

            loadedSet(true);
            loadingSet(false);
        })
    }

    function LoadingDone(length) {

        offset.current += 10;

        moreSet(length >= 10);

        loadingSet(false);
    }



    function ContextAwareToggle({ children, eventKey, callback, data, idx }) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(eventKey, () => {
            if (activeEventKey !== eventKey && callback) {
                callback(true);
            }
        });

        const d = data;
        const i = idx;

        return (
            <>
                <div className={"border-0 rounded-4 w-100 text-white " + (activeEventKey === eventKey ? 'bg-dark' : 'bg-secondary')}
                    style={{ padding: '1px' }}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseThree"
                >
                    <div className=''  >
                        <button className='d-flex px-3 align-items-center w-100 border-0 text-white bg-transparent' style={{ height: '60px' }} onClick={decoratedOnClick}>
                            <div className='flex-grow-1 text-start align-self-center'>
                                <div>{d.title}</div>
                                {activeEventKey === eventKey && <div className='fs-7 text-secondary'>{d.tag}</div>}
                            </div>
                            <div className='d-flex justify-content-end' style={{ width: '80px' }}>
                                <span className='px-1'>
                                    {d.qz.length}
                                </span>
                                <i class={activeEventKey === eventKey ? 'fi-rr-angle-up va-m' : 'fi-rr-angle-down va-m'}></i>
                            </div>
                        </button>

                        <Card className='border-0  bg-transparent'>

                            <Card.Body className='p-0 border-0'>
                                {GameSlot(i, d, 0, activeEventKey === eventKey)}
                            </Card.Body>
                            <Accordion.Collapse eventKey={i + 1}>
                                <Card.Body className='p-0'>

                                    <ListGroup className='rounded-4 rounded-top-0' variant="flush" style={{ gap: '1px', marginTop: '1px' }}>
                                        {
                                            d.qz.map((z, ic) => {
                                                if (ic > 0) {
                                                    return (
                                                        <ListGroup.Item className='p-0'>
                                                            {GameSlot(i, d, ic, false)}
                                                        </ListGroup.Item>
                                                    )
                                                }
                                            })
                                        }
                                    </ListGroup>

                                </Card.Body>

                            </Accordion.Collapse>
                        </Card>

                    </div>

                </div>
                {
                    activeEventKey === eventKey && (
                        <div className='d-flex align-items-center justify-content-center px-3' style={{ height: '50px' }}>

                            <dic className='px-1'>
                                <span className='badge text-bg-light bg-transparent'><i class='fi-sr-play'></i>  {d.used}</span>
                            </dic>

                            <div className='d-flex flex-grow-1 px-3 justify-content-center align-items-center' style={{ height: '50px' }}>
                                <Button className='rounded-pill px-3 py-2 flex-grow-1 text-white' style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    minWidth: '150px',
                                    maxWidth: '100%',
                                }} onClick={() => {
                                    showAppDownloadModalSet(true);
                                }}>
                                    <span
                                        style={{
                                            display: 'block',
                                            fontSize: 'clamp(12px, 2vw, 16px)',
                                        }}
                                    >
                                        이 게임으로 궁합보기
                                    </span>
                                </Button>
                            </div>

                            {modLib && (
                                <span className='px-1 text-decoration-underline' onClick={() => { dispatch(Setlib({ modal: true, uuid: d.User_uid })) }}>
                                    <span className='fs-7'><i class='fi-rr-user'></i>  {d.maker}</span>
                                </span>
                            )}

                        </div>
                    )
                }
            </>

        );
    }


    function GameSlot(gi, qz, qi, open) {
        const imgA = qz.qz[qi][3] == '@';
        const imgB = qz.qz[qi][4] == '@';

        const keyA = Static.ImgType.lib + qz.uid + '_' + qi + '-' + 'A';
        const keyB = Static.ImgType.lib + qz.uid + '_' + qi + '-' + 'B';

        console.log('Image Keys:', { keyA, keyB, imgA, imgB });
        console.log('Quiz data:', qz.qz[qi]);
        console.log('Store Images:', store.img);

        const styImg = {
            objectFit: 'cover',
            aspectRatio: 5 / 3,
            width: '100%'
        }

        return (

            <button className={'d-flex flex-column p-2 w-100 bg-white border-0 rounded-4 justify-content-center align-items-center ' + (open ? 'rounded-bottom-0' : '')}
                onClick={() => {
                    // 이미지 키 추가 및 로드
                    if (imgA) {
                        addImgKey(keyA);
                    }
                    if (imgB) {
                        addImgKey(keyB);
                    }

                    // 이미지가 있으면 로드
                    if (imgA || imgB) {
                        loadImgs();
                    }

                    // 클릭한 슬롯 정보를 저장하고 모달 열기
                    selectedSlotSet({
                        gameIndex: gi,
                        quizData: qz,
                        quizIndex: qi,
                        keyA: keyA,
                        keyB: keyB,
                        imgA: imgA,
                        imgB: imgB
                    });
                    showModalGameSlotSet(true);
                }}>

                {qz.qz[qi][0] != '' && (
                    <div className='my-3 justify-content-center align-items-center'>
                        {qz.qz[qi][0]}
                    </div>
                )}

                <div className='d-flex align-items-center w-100'>

                    <div className='d-flex flex-column col'>
                        {imgA ? (
                            <>
                                <ImgSlot imgKey={keyA} className='rounded-4' style={styImg} />
                                {qz.qz[qi][1]}
                            </>
                        ) : (
                            <div className='fs-6'>
                                {qz.qz[qi][1]}
                            </div>
                        )}
                    </div>

                    <div className='align-self-center'>
                        <img className='' src={ImgVs} style={{ height: '40px', width: '40px' }} />
                    </div>

                    <div className='d-flex flex-column col'>
                        {imgB ? (
                            <>
                                <ImgSlot imgKey={keyB} className='rounded-4' style={styImg} />
                                {qz.qz[qi][2]}
                            </>
                        ) : (
                            <div className='fs-6'>
                                {qz.qz[qi][2]}
                            </div>
                        )}

                    </div>
                </div>
            </button>


        )
    }

    function AddLoadImg(uid, qz) {
        qz.map((d, i) => {
            if (d[3] == '@') {
                let keyA = Static.ImgType.lib + uid + '_' + i + '-A';
                addImgKey(keyA);
            }
            if (d[4] == '@') {
                let keyB = Static.ImgType.lib + uid + '_' + i + '-B';
                addImgKey(keyB);
            }
        })
    }

    // 모든 이미지가 로드될 때까지 기다리는 함수
    async function waitForImagesToLoad(element) {
        const images = element.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
            if (img.complete) {
                return Promise.resolve();
            }
            return new Promise((resolve, reject) => {
                img.onload = resolve;
                img.onerror = resolve; // 에러가 나도 계속 진행
                // 타임아웃 추가 (5초)
                setTimeout(resolve, 5000);
            });
        });
        await Promise.all(imagePromises);
    }

    // 모달 내용을 이미지로 저장하는 함수
    async function SaveSlotAsImage() {
        if (!modalContentRef.current || !selectedSlot) {
            return;
        }

        try {
            // 토스트 메시지 표시
            toast.loading('이미지를 생성 중입니다...', { id: 'saving' });

            // 모든 이미지가 로드될 때까지 대기
            await waitForImagesToLoad(modalContentRef.current);

            // 잠시 대기 (렌더링 완료 확인)
            await new Promise(resolve => setTimeout(resolve, 500));

            // html2canvas를 사용하여 모달 내용을 캡처
            const canvas = await html2canvas(modalContentRef.current, {
                backgroundColor: '#ffffff',
                scale: 2, // 고화질을 위해 스케일 증가
                logging: true,
                useCORS: true, // CORS 이미지 허용
                allowTaint: true, // CORS가 없는 이미지도 캡처
                foreignObjectRendering: false,
                imageTimeout: 0, // 이미지 로딩 타임아웃 제거
            });

            // 캔버스를 Blob으로 변환
            canvas.toBlob((blob) => {
                if (!blob) {
                    toast.error('이미지 생성에 실패했습니다.', { id: 'saving' });
                    return;
                }

                // 다운로드 링크 생성
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                const fileName = `${selectedSlot.quizData.title}_${selectedSlot.quizIndex + 1}.png`;

                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // 메모리 정리
                URL.revokeObjectURL(url);

                toast.success('이미지가 저장되었습니다!', { id: 'saving' });
            }, 'image/png');

        } catch (error) {
            console.error('이미지 저장 실패:', error);
            toast.error('이미지 저장에 실패했습니다.', { id: 'saving' });
        }
    }




    if (lib == null) {
        return ShowLoading()
    }

    return (
        <div className='pt-1 pb-5'>
            <style jsx>{`
                .modal-backdrop-show {
                    z-index: 1055 !important;
                    background-color: rgba(0, 0, 0, 0.5) !important;
                }
                .modal-backdrop-show.show {
                    opacity: 1 !important;
                }
            `}</style>
            <fieldset disabled={loading}>

                {!modLib && (
                    <div className='my-3'>
                        <div className='d-flex  py-3'>

                            <div className='d-flex flex-grow-1 align-items-center fs-4'>
                                <span className='fw-bold'>{my.nick}</span>님이 공유한 게임
                            </div>
                            <div className='px-3 text-center'>
                                <span className='fs-2'>{my.lib}</span>
                                <br></br>
                                공유됨
                            </div>
                            <div className='px-3 text-center'>
                                <span className='fs-2'>{my.used}</span>
                                <br></br>
                                사용됨
                            </div>
                        </div>


                        <div className='my-3' >
                            <Adsense type='dp' />
                        </div>

                    </div>

                )}

                <Toaster />

                <>
                    <div className='bg-white' style={{ position: 'sticky', top: 0, zIndex: 1000, }}>
                        <Tabs defaultActiveKey={sessionStorage.getItem(_ORDER) === '1' ? '1' : '0'}
                            className="m-3 border-bottom custom-tabs"
                            variant='underline'
                            justify
                            onSelect={(e) => {
                                if (e == '0') { sessionStorage.setItem(_ORDER, '0'); order.current = 0; rendFindSet(false); ClickOrderTab(); }
                                if (e == '1') { sessionStorage.setItem(_ORDER, '1'); order.current = 1; rendFindSet(false); ClickOrderTab(); }
                                if (e == '2') {
                                    order.current = 2;
                                    rendFindSet(true);
                                    findwordDoneSet(findword);
                                    if (findword == '') {
                                        libSet([]);
                                        moreSet(false);
                                    }
                                    else {
                                        SearchLib();
                                    }
                                    setTimeout(() => {
                                        if (taRefFind.current != null) {
                                            taRefFind.current.focus();
                                        }
                                    }, 10);
                                }
                            }}>
                            <Tab eventKey="0" title="인기순"></Tab>
                            <Tab eventKey="1" title="최신순"></Tab>
                            <Tab eventKey="2" title="찾기"></Tab>
                        </Tabs>
                    </div>


                    {rendFind && (
                        <div className='text-center'>
                            <div class="mx-5 my-4">
                                <div className='input-group'>
                                    <input type="text" class="form-control" ref={taRefFind} value={findword} onChange={(e) => {
                                        findwordSet(e.target.value);
                                    }}
                                        onKeyDown={(e) => {
                                            if (e.nativeEvent.isComposing || e.target.value == '') {
                                                return;
                                            }
                                            if (e.code === 'Enter' || e.code === 'NumpadEnter') {
                                                SearchLib();
                                            }
                                        }}
                                    />
                                    <button class="btn btn-outline-secondary" type="button" onClick={() => { SearchLib() }}><i class="fi-rr-search va-m px-2"></i></button>
                                </div>

                                <div className='mt-2'>
                                    <Tabs defaultActiveKey={orderFind.current}
                                        className=""
                                        variant='pills'
                                        justify
                                        onSelect={(e) => {
                                            if (e == '0') { orderFind.current = 0; SearchLib(); }
                                            if (e == '1') { orderFind.current = 1; SearchLib(); }
                                            if (e == '2') { orderFind.current = 2; SearchLib(); }
                                            if (e == '3') { orderFind.current = 3; SearchLib(); }
                                        }}>

                                        <Tab eventKey="0" title={<span>태그</span>}></Tab>
                                        <Tab eventKey="1" title={<span>제목</span>}></Tab>
                                        <Tab eventKey="2" title={<span>문제</span>}></Tab>
                                        {modLib && (<Tab eventKey="3" title={<span>유저</span>}></Tab>)}
                                    </Tabs>
                                </div>
                            </div>


                            {!loading &&
                                (findwordDone == '' ? (
                                    <>
                                        키워드를 입력하세요.
                                    </>
                                ) : (
                                    lib.length == 0 && (
                                        <>
                                            '{findwordDone}' 이건 하나도 없어요.
                                        </>
                                    )
                                ))}
                        </div>
                    )}



                    <>

                        {(modLib && !rendFind) && (
                            <div className='my-4'>
                                <ul class="nav nav-pills" id="tab_tag" role="tablist" >
                                    <li class="nav-item m-1 rounded-pill border border-1" role="presentation">
                                        <button class="nav-link rounded-pill" id="pills-home-tab" eventKey='-1' data-bs-toggle="pill" data-bs-target="#all" type="button" role="tab" aria-controls="all" aria-selected="true"
                                            onClick={() => { findwordRef.current = '%'; tabInit.current = true; ReOrderLib(); }} >전체</button>
                                    </li>
                                    {tags.map((d, i) => (
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link m-1 rounded-pill border border-1" eventKey={i} data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false"
                                                onClick={() => { findwordRef.current = d.tag; tabInit.current = true; ReOrderLib(); }} >#{d.tag}</button>
                                        </li>
                                    ))}

                                </ul>
                            </div>
                        )}






                        {loading ? (ShowLoading()) : (
                            (!rendFind && loaded && lib.length == 0) && (
                                <div className='my-5 text-center'>
                                    아직 하나도 없어요.
                                </div>
                            )
                        )}



                        <div className='text-center d-flex flex-column gap-5'>
                            {lib.map((d, i) => {

                                return (
                                    <>
                                        <Accordion>
                                            <ContextAwareToggle
                                                data={d}
                                                idx={i}
                                                eventKey={i + 1}
                                                callback={(e) => { AddLoadImg(d.uid, d.qz); loadImgs(); }}
                                            >
                                            </ContextAwareToggle>
                                        </Accordion>



                                        {(i > 0) && (i % 4 == 0) && (
                                            <div className=''>
                                                <Adsense type='dp' />
                                            </div>
                                        )}

                                    </>
                                )
                            })}



                        </div >
                    </>

                </>


                <div className='p-3'>
                </div>

                {more && (<>
                    <div className='m-3' ref={moreRef}><Spinner animation="border" /></div>
                </>)}


                <div className='my-1'>
                    <Adsense type='ia' />
                </div>





            </fieldset>

            {/* GameSlot 모달 */}
            <Modal 
                show={showModalGameSlot} 
                onHide={() => showModalGameSlotSet(false)} 
                centered 
                size="lg" 
                backdrop={true}
                backdropClassName="modal-backdrop-show"
                style={{zIndex: 1060}}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedSlot && selectedSlot.quizData.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedSlot && (
                        <div ref={modalContentRef} className='d-flex flex-column p-2 p-md-4 w-100 justify-content-center align-items-center' style={{ backgroundColor: '#ffffff' }}>
                            {selectedSlot.quizData.qz[selectedSlot.quizIndex][0] != '' && (
                                <div className='my-3 justify-content-center align-items-center fs-5 fw-bold'>
                                    {selectedSlot.quizData.qz[selectedSlot.quizIndex][0]}
                                </div>
                            )}

                            <div className='d-flex align-items-center w-100'>
                                <div className='d-flex flex-column col align-items-center'>
                                    {selectedSlot.imgA ? (
                                        <>
                                            {store.img[selectedSlot.keyA] ? (
                                                <div
                                                    className='rounded-4'
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '300px',
                                                        aspectRatio: '1 / 1',
                                                        backgroundImage: `url(${store.img[selectedSlot.keyA]})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        backgroundRepeat: 'no-repeat'
                                                    }}
                                                />
                                            ) : (
                                                <p className="placeholder-glow m-0">
                                                    <span className="rounded-4 placeholder bg-secondary" style={{ width: '100%', maxWidth: '300px', aspectRatio: '1 / 1', display: 'block' }}></span>
                                                </p>
                                            )}
                                            <div className='mt-2 text-center fw-semibold'>
                                                {selectedSlot.quizData.qz[selectedSlot.quizIndex][1]}
                                            </div>
                                        </>
                                    ) : (
                                        <div className='fs-5 text-center'>
                                            {selectedSlot.quizData.qz[selectedSlot.quizIndex][1]}
                                        </div>
                                    )}
                                </div>

                                <div className='align-self-center mx-2 mx-md-3 flex-shrink-0'>
                                    <img className='' src={ImgVs} style={{ height: 'clamp(40px, 8vw, 60px)', width: 'clamp(40px, 8vw, 60px)' }} alt='vs' crossOrigin="anonymous" />
                                </div>

                                <div className='d-flex flex-column col align-items-center'>
                                    {selectedSlot.imgB ? (
                                        <>
                                            {store.img[selectedSlot.keyB] ? (
                                                <div
                                                    className='rounded-4'
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '300px',
                                                        aspectRatio: '1 / 1',
                                                        backgroundImage: `url(${store.img[selectedSlot.keyB]})`,
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        backgroundRepeat: 'no-repeat'
                                                    }}
                                                />
                                            ) : (
                                                <p className="placeholder-glow m-0">
                                                    <span className="rounded-4 placeholder bg-secondary" style={{ width: '100%', maxWidth: '300px', aspectRatio: '1 / 1', display: 'block' }}></span>
                                                </p>
                                            )}
                                            <div className='mt-2 text-center fw-semibold'>
                                                {selectedSlot.quizData.qz[selectedSlot.quizIndex][2]}
                                            </div>
                                        </>
                                    ) : (
                                        <div className='fs-5 text-center'>
                                            {selectedSlot.quizData.qz[selectedSlot.quizIndex][2]}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center gap-1">
                    <Button
                        variant=""
                        className="rounded-pill px-4 py-3 fw-bold flex-fill text-primary border-primary"
                        onClick={SaveSlotAsImage}
                    >
                        <i className="fi-rr-download me-2"></i>
                        이미지로 저장
                    </Button>
                    <Button
                        variant="primary"
                        className="rounded-pill px-4 py-3 fw-bold flex-fill"
                        style={{ color: 'white' }}
                        onClick={() => {
                            showModalGameSlotSet(false);
                            showAppDownloadModalSet(true);
                        }}
                    >
                        이 질문으로 궁합보기
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* 앱 다운로드 모달 */}
            <AppDownloadModal 
                show={showAppDownloadModal} 
                onHide={() => showAppDownloadModalSet(false)} 
            />
        </div>


    )
}
